import { useCallback, useEffect, useMemo, useState } from 'react';

import { useUserPrint } from '@app/hooks';
import type { NFunnels } from '@app/types';
import { createWSConnection } from '@app/utils';
import {
  invokeWSMethod,
  subscribeToWsEvent,
} from '@app/utils/createWSConnection';

export const useEditSalesFunnelEffects = () => {
  const [robotsWithProgress, setRobotsWithProgress] = useState<
    NFunnels.RobotTaskGroupProgressEventType[]
  >([]);

  const memoizedRobotsWithProgress = useMemo(
    () => robotsWithProgress,
    [robotsWithProgress]
  );

  const { database } = useUserPrint();

  const createHubConnection = useCallback(() => {
    createWSConnection(async () => {
      await invokeWSMethod('ListenOrganization', database);

      subscribeToWsEvent(
        'RobotTaskGroupProgressEvent',
        (data: NFunnels.RobotTaskGroupProgressEventType) => {
          setRobotsWithProgress((prev) => {
            const existingIndex = prev.findIndex(
              (item) => item.robotId === data.robotId
            );

            if (existingIndex !== -1) {
              const updated = [...prev];
              updated[existingIndex] = data;
              return updated;
            }
            return [...prev, data];
          });
        }
      );
    });
  }, [database]);

  useEffect(() => {
    createHubConnection();
  }, [createHubConnection]);

  return {
    memoizedRobotsWithProgress,
  };
};
